;(function (global, factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        factory(module, global);
    } else {
        factory({}, global);
    }
})(window || this, function (module, window) {

    function getQueryString( name ) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = decodeURIComponent(location.search).substr(1).match(reg);
        if (r != null)
            return unescape(r[2]);
        return null;
    }
    function scheme(url){
        var ifr = document.createElement('iframe');
        ifr.src = url;
        ifr.style.display = 'none';
        document.body.appendChild(ifr);
    }

    var mclient = {};
    mclient.os = function(){
        /*var isAndroid = navigator.userAgent.indexOf('Android') > -1;
        var os = getQueryString('os');
        if(os)
            return os.toLowerCase();
        else
            return isAndroid ? "android" : "ios";*/
        var isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            isAndroid = navigator.userAgent.indexOf('Android') > -1;
        var queryString = window.location.search;
            queryString = queryString.toLowerCase();
        if(queryString.indexOf("os=android") > -1){
            return "android";
        }else if(queryString.indexOf("os=ios") >-1){
            return "ios";
        }else{  
            return "notapp"         
            /*if(isIos){
                return "ios";
            }else if(isAndroid){
                return "android";
            }else{
                return "notapp"
            }*/
        }
    }();
    // web调用Native 方法统一入口
    mclient.nativeMethod = function(param){
        if( !param ) {
            return;
        }

        console.info('scheme %o', param);
        param = JSON.stringify(param);

        if(mclient.os == "ios")
            scheme('hybrid://nativechannel/' + encodeURI(param));
        else if(mclient.os == "android")
            window.stub && window.stub.jsCallMethod(param);
    };
    // Native调用web 方法统一入口
    mclient.webMethod = function(param){
        var action = param.action;
        if( mclient.task[action] ){
            mclient.task[action]( param.param );
        }
    };
    mclient.task = {};
    mclient.on = function(action, fn){
        if( fn ) {
            mclient.task[action] = fn;
        }
    };
    mclient.send = function(action, data){
        mclient.nativeMethod({
            action: action,
            param:  data
        });
    };
    (function(){
        window['$'] = window['$'] || {};
        window['jq'] = window['jq'] || {};

        window['$']['mclient'] = window['jq']['mclient'] = mclient;
    })();



    function app(){
        this.os = mclient.os;
        /*this.isApp = this.os == 'ios' || (this.os == 'android' && window.stub);*/
        this.isApp = this.os == 'notapp' ? false : true;
        // test
        //this.isApp = true;
    }

    // 添加学员
    app.prototype.addStudent = function(){
        scheme('supercoach://student/add');
    };

    // 编辑招生名片
    app.prototype.editCard = function(){
        //scheme('supercoach://recruit/card');

        var data = {
            uri: 'businessCardEdit',
            title: '编辑名片',
            parameter: {
                isComingEdit: 1
            }
        };

        mclient.send('openuri', data);
    };

    // 保存图片
    app.prototype.saveImage = function(url){

        if( !/^data:/.test(url) ){
            url = encodeURIComponent(url);
        }
        scheme('supercoach://image/save?url=' + url);
    };

    // 添加分享菜单(右上角)
    app.prototype.addShare = function(param){
        var data = {
            showShareButton: 1,
            data: {
                "articleType": 1,
                "title":    param.title,
                "content":  param.desc,
                "picurl":   param.imgUrl,
                "url":      param.link,
            }
        };
        mclient.on('sharedown', param.success);
        mclient.send('setShareInfo', data);
    };

    // 添加分享菜单(底部弹出)
    app.prototype.showShare = function(param){
        var data = {
            showShareButton: 1,
            data: {
                "articleType": 1,
                "title":    param.title,
                "content":  param.desc,
                "picurl":   param.imgUrl,
                "url":      param.link,
            }
        };
        mclient.on('sharedown', param.success);
        mclient.send('bonusshare', data);
    };

    // 显示右上角菜单
    app.prototype.showMenu = function(param){
        var data = {
            showRightButton: 1,
            "title":        param.title || '',
            "rightText":    param.btnText,
            "openUrl":      param.btnLink
        };
        mclient.send('customRight', data);
    };

    // 隐藏右上角菜单
    app.prototype.hideMenu = function(){
        var data = {
            showRightButton: 0,
            "title":        '',
            "rightText":    '',
            "openUrl":      ''
        };
        mclient.send('customRight', data);
    };

    // 返回上一层
    app.prototype.goBack = function(){
        scheme('supercoach://webview/close');
    };

    // 上传图片
    app.prototype.chooseImg = function( param ){
        param = param || {};
        var data = {
            "num":      param.num || 1,  // 最多选择图片数量
            "isedit":   param.isedit || false,
            "picpath":  param.picpath || ''
        };
        mclient.on('publishphotodown', param.success);
        mclient.send('publishphoto', data);
    };

    // 打开新的webview
    app.prototype.openWebview = function( param ){
        param = param || {};
        var data = {
            title: param.title || '',
            url: param.url || ''
        };
        mclient.send('openwebview', data);
    };

    // webview重新显示在前台时候是否要刷新 1 刷新 0 不刷新 
    app.prototype.refresh = function(n){
        scheme('supercoach://webview/appear?refresh=' + n);
    };

    /**
     * 版本号转数字
     */
    app.prototype.versionToInt = function( v ){
        var maxLen = 4;

        var num = v.toString().replace(/\./g, '');
        var needLen = maxLen - Math.min(num.length, maxLen);

        return parseInt('' + num + new Array(needLen + 1).join('0') );
    };

    // 分享图片
    app.prototype.shareImage = function(url){

        if( !/^data:/.test(url) ){
            url = encodeURIComponent(url);
        }
        scheme('supercoach://image/share?url=' + url);
    };

    // 分享图片(小程序)
    app.prototype.shareImageII = function(url, channel, text){
        if( !/^data:/.test(url) ){
            url = encodeURIComponent(url);
        }
        scheme('supercoach://image/share?channel=' + channel + '&spt=' + text + '&url=' + url);
    };

    // 分享图片(小程序)
    app.prototype.shareImageIII = function(url, param){
        var wx_id = param.wxid || 'wx2c19e106e57df79b'
        var wxsecret = param.wxsecret || 'f175980b177664464a81e88483e63b74'
        if( !/^data:/.test(url) ){
            url = encodeURIComponent(url);
        }
        scheme('supercoach://image/share?channel=' + param.channel +'&wxid='+ wx_id +'&wxsecret='+ wxsecret +'&spt=' + param.spt + '&spd=' + param.spd + '&spid=' + param.spid + '&spscheme=' + param.spscheme + '&url=' + url);
    };


    // 小程序 base 64 公共回调
    app.prototype.public_callback = function( param ){
    	console.info('scheme_fn', param)
        param = param || {};
        mclient.on('share_public_callback', param.success);
    };
    // 统计
    app.prototype.statistics = function(key, param){
        scheme('supercoach://statistics/config?key=' + key + '&param=' + param);
    };
    app.prototype.statistic = function(key, params){
        scheme('supercoach://statistics/?key=' + key + '&param=' + param);
    };

    window._jl = module.exports = new app();
});



//////////////////
// WEBPACK FOOTER
// ./static/js/chaojijiaolian-jl.js
// module id = Ix5S
// module chunks = 1